'use strict';

import translator from '../translator';

const config = {
    target: '.js-comment-card',
    replyButton: '.js-comment-action-reply',
    deleteButton: '.js-comment-action-delete',
    reportButton: '.js-comment-action-report',
    replyForm: '.js-comment-reply-form',
    userName: '.js-avatar-title',
    i18n: {
        deleteConfirmation: translator.getTranslationByKey('commentcard', 'delete_confirmation'),
        reportConfirmation: translator.getTranslationByKey('commentcard', 'report_confirmation')
    }
};

/**
 * CommentCard
 *
 * Component for handling interactions with comments (deletion/reporting etc.).
 */
class CommentCard {

    /**
     * Constructor.
     *
     * @param {jQuery} $el The element for the component.
     */
    constructor($el) {
        $el.on('click', config.replyButton, (e) => this.displayReplyForm(e));
        $el.on('click', config.reportButton, () => this.displayConfirmation(config.i18n.reportConfirmation));
        $el.on('click', config.deleteButton, () => this.displayConfirmation(config.i18n.deleteConfirmation));
    }

    /**
     * Display a confirmation message.
     *
     * @param {string} message The message to display.
     *
     * @return {bool} True if the user confirms the action, otherwise false.
     */
    displayConfirmation(message) {
        return confirm(message);
    }

    /**
     * An Ajax call to retrieve reply form for a comment
     *
     * @param {jQuery.event} e
     */
    displayReplyForm(e) {
        const button = $(e.target);
        const commentCard = button.closest('.c-comment-card');
        const comment = button.closest('.c-comment');
        const loadingModifier = 'c-button--loading';

        // If we have a form next door it's probably a reply to our form?
        if (comment.next(config.replyForm).length > 0) {
            comment.next(config.replyForm).slideUp('fast', function() {
                $(this).remove();
            });
            return;
        }

        button.addClass(loadingModifier);

        $.ajax({
            url: button.data('reply-url'),
            method: 'GET',
            data: {
                comment_id: commentCard.data('comment-id'),
                user_name: commentCard.find(config.userName).data('avatar-title')
            }
        })
        .done((response) => {
            const form = $(response);
            comment.after(form);
            $('body').animate({scrollTop: form.offset().top - 10}); // -10 to give a little margin
            form.css({'display': 'none'}).slideDown('fast');
        })
        .fail(() => alert('Couldn\'t get reply form'))
        .always(() => button.removeClass(loadingModifier));
    }
}

$(window).load(function() {
    $(config.target).each(function () {
        new CommentCard($(this));
    });
});



// WEBPACK FOOTER //
// ./src/js/components/comment-card.js